<template>
    <div>
        <form @submit.prevent="onSearch" class="mb-2">
            <input type="text" name="search" class="search" placeholder="" autocomplete="off" v-model="search">
            <button type="submit" class="btn btn-outline-secondary mt-2" v-if="false">Search</button>
        </form>
        <b-list-group>
            <b-list-group-item class="bg-light font-weight-bold">
                <div class="d-none d-md-block">
                    <div class="row">
                        <div class="col-1">TYPE</div>
                        <div class="col-2">#REF</div>
                        <div class="col-3">ITEM</div>
                        <div class="col-2">QTY</div>
                        <div class="col-1">LOT</div>
                        <div class="col-1">SERIAL</div>
                        <div class="col-2">CREATED</div>
                    </div>
                </div>
                <div class="d-block d-sm-block d-md-none">
                    <div class="row">
                        <div class="col-2">TYPE</div>
                        <div class="col-10">ITEM</div>
                    </div>
                </div>
            </b-list-group-item>
            <b-list-group-item v-for="(item, index) in rows" v-bind:key="index">
                <div class="d-block d-sm-block d-md-none">
                    <div class="row">
                        <div class="col-2">
                            <span v-html="classColor(item)"></span>
                        </div>
                        <div class="col-10">{{item.description}}</div>

                        <div class="col-6">Ref# {{item.reference}}</div>
                        <div class="col-6">Lot# {{item.lot}}</div>
                        <div class="col-6">S# {{item.serial}}</div>
                        <div class="col-6">{{item.qty}} {{item.unit | uppercase}}</div>
                    </div>
                </div>
                <div class="d-none d-md-block">
                    <div class="row">
                        <div class="col-1">
                            <span v-html="classColor(item)"></span>
                        </div>
                        <div class="col-2">{{item.reference}}</div>
                        <div class="col-3">{{item.description}}</div>
                        <div class="col-2">{{item.qty}} {{item.unit | uppercase}}</div>
                        <div class="col-1">{{item.lot}}</div>
                        <div class="col-1">{{item.serial}}</div>
                        <div class="col-2">{{item.created}}</div>
                    </div>
                </div>
            </b-list-group-item>
            <li class="list-group-item text-center" v-if="rows.length===0">No Content</li>
        </b-list-group>
        <div class="fixed-bottom d-flex">
            <div class="mx-auto" v-if="totalPages>1">
                <b-pagination-nav :link-gen="linkGen" @change="pageChange" :number-of-pages="totalPages" use-router/>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "MovesList",
        mounted() {
            this.pageChange()
        },
        data() {
            return {
                search: '',
                limit: (window.innerWidth <= 425 ? 4 : 10),
                rows: [],
                total: 0,
            }
        },
        computed: {
            totalPages() {
                return Math.ceil(this.total / this.limit)
            },
        },
        methods: {
            onSearch() {
                this.pageChange();
            },
            classColor(item) {
                switch (item.type) {
                    case 'incoming':
                        return '<span class="badge badge-success">IN</span>';
                    case 'outgoing':
                        return '<span class="badge badge-danger">OUT</span>';
                    default:
                        return 'badge-secondary';
                }
            },
            pageChange(page = 1) {
                this.$emit('spinner', true);
                axios.get(`/moves?search=${this.search}&offset=${page === 1 ? 0 : (page * this.limit) - this.limit}&limit=${this.limit}`)
                    .then((result) => {
                        this.rows = result.data.rows;
                        this.total = result.data.total;
                        this.$emit('spinner', false);
                    })
                    .catch(() => this.$emit('spinner', false));
            },
            linkGen(pageNum) {
                return (pageNum === 1 ? '?' : `?page=${pageNum}`);
            }
        }
    }
</script>

<style scoped>
    input.search {
        width: 130px;
        box-sizing: border-box;
        border: 2px solid #ccc;
        border-radius: 4px;
        font-size: 16px;
        background-color: white;
        background-image: url('~@/assets/searchicon.png');
        background-position: 10px 10px;
        background-repeat: no-repeat;
        padding: 12px 20px 12px 40px;
        -webkit-transition: width 0.4s ease-in-out;
        transition: width 0.4s ease-in-out;
    }

    input.search:focus {
        width: 100%;
    }
</style>